var map = {
	"./default_bg_1.png": 690,
	"./default_bg_1_2.png": 691,
	"./default_bg_1_3.png": 692,
	"./default_bg_1_4.png": 693,
	"./default_bg_1_5.png": 694,
	"./default_bg_1_6.png": 695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1861;